import { GlobalStyles, ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material'
import { ReactNode } from 'react'
import { darkTheme, globalStyles, theme } from './theme2/theme'

export const ThemeProvider = ({ children, mode = 'light' }: { children: ReactNode; mode?: 'light' | 'dark' }) => (
  <StyledEngineProvider injectFirst>
    <MuiThemeProvider theme={mode === 'dark' ? darkTheme : theme}>
      <GlobalStyles styles={globalStyles} />
      {children}
    </MuiThemeProvider>
  </StyledEngineProvider>
)
